import { ALERT_SELECT } from "../actionTypes/index"

export const handleSelect = (value) => async dispatch => {
    dispatch({ type: ALERT_SELECT, payload: value });

}